import { CSSProperties } from "react";

export const ATTACHMENT_FIELD_STYLES = {
  container: {
    width: "100%"
  } as CSSProperties,

  dragDropZone: (isDragOver: boolean, disabled: boolean): CSSProperties => ({
    border: isDragOver ? "2px dashed #007bff" : "2px dashed #ddd",
    borderRadius: "4px",
    padding: "20px",
    textAlign: "center",
    backgroundColor: isDragOver ? "#f8f9fa" : "#fafafa",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1,
    marginBottom: "10px"
  }),

  hiddenInput: {
    display: "none"
  } as CSSProperties,

  label: (disabled: boolean): CSSProperties => ({
    cursor: disabled ? "not-allowed" : "pointer",
    display: "block"
  }),

  helpText: {
    color: "#666"
  } as CSSProperties,

  fileInfo: {
    fontSize: "12px",
    color: "#666",
    marginBottom: "10px"
  } as CSSProperties,

  errorContainer: {
    marginBottom: "10px"
  } as CSSProperties,

  errorItem: {
    color: "#dc3545",
    fontSize: "12px",
    marginBottom: "4px"
  } as CSSProperties,

  fileListContainer: {
    marginTop: "10px"
  } as CSSProperties,

  fileListHeader: {
    fontSize: "14px",
    fontWeight: "bold",
    marginBottom: "8px"
  } as CSSProperties,

  fileItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    marginBottom: "4px",
    backgroundColor: "#fff"
  } as CSSProperties,

  fileDetails: {
    flex: 1
  } as CSSProperties,

  fileName: {
    fontSize: "13px",
    fontWeight: "500"
  } as CSSProperties,

  fileSize: {
    fontSize: "11px",
    color: "#666"
  } as CSSProperties,

  removeButton: {
    background: "none",
    border: "none",
    color: "#dc3545",
    cursor: "pointer",
    fontSize: "16px",
    padding: "4px"
  } as CSSProperties
} as const;
